import groupBy from 'lodash-es/groupBy.js';
import keyBy from 'lodash-es/keyBy.js';
import { match } from 'ts-pattern';
import { EndPanel as V6EndPanel } from '../__generated/model/versions/v6.js';
import { Model, round } from '../index.js';
export const migrateToV7 = (state)=>{
    const migratedState = state.map((entity)=>{
        return match(entity).returnType()// EndPanel doesn't have a depth anymore.
        // It's calculated automatically based on wall existence.
        .when((e)=>V6EndPanel.isId(e.id), ({ depth, ...entity })=>entity)// Clone everything, we might mutate it later.
        .otherwise((other)=>Object.assign({}, other));
    });
    // Group items by wallId and sort them by x position
    const bottomWallItems = migratedState.filter((e)=>Model.BottomWallItem.is(e));
    const walls = migratedState.filter((e)=>Model.Wall.is(e));
    const itemsByWall = groupBy(bottomWallItems, 'wallId');
    const wallsById = keyBy(walls, 'id');
    // Mutate migrated state. It's already cloned, so we can mutate it.
    for (const [wallId, items] of Object.entries(itemsByWall)){
        const wall = wallsById[wallId];
        if (!wall) {
            throw new Error(`Wall ${wallId} not found`);
        }
        // Sort items within each wall by x position
        // Depends on wall type if items are added from left or right
        const direction = wall.wallType === 'A' ? 'left' : 'right';
        const itemsSorted = items.sort((a, b)=>{
            return direction === 'right' ? a.x - b.x : b.x - a.x;
        });
        // When items are added from left, even the first item has a gap.
        const startIndex = direction === 'right' ? 1 : 0;
        const gap = round(1 / 32 * 25.4, 4);
        for(let i = startIndex; i < itemsSorted.length; i++){
            const item = itemsSorted[i];
            if (!item) {
                throw new Error(`Item ${i} not found`);
            }
            const writtableItem = item;
            if (direction === 'right') {
                writtableItem.x += i * gap;
            } else {
                // Even first item has a gap
                writtableItem.x -= (i + 1) * gap;
            }
        }
    }
    return migratedState;
};

//# sourceMappingURL=v07.js.map